import { render, staticRenderFns } from "./ArticleActions.vue?vue&type=template&id=ad0606ec&scoped=true&"
import script from "./ArticleActions.vue?vue&type=script&lang=ts&"
export * from "./ArticleActions.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleActions.vue?vue&type=style&index=0&id=ad0606ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0606ec",
  null
  
)

export default component.exports